export interface VaccineTypeValue {
  id: string
  value: string
}

interface OccurrenceProps {
  [key: string]: VaccineTypeValue
}

export const occurrence: OccurrenceProps = {
  morte: {
    id: 'morte',
    value: 'Morte'
  }
}

export const causes: OccurrenceProps = {
  doenca: {
    id: 'doenca',
    value: 'Doença'
  },
  sacrificio: {
    id: 'sacrificio',
    value: 'Sacrifício'
  }
}

export const occurrenceOptions = Object.keys(occurrence).map((key: string) => occurrence[key])
export const causesOptions = Object.keys(causes).map((key: string) => causes[key])
